import React from 'react';
import RadioButton from '../radio-button/radio-button';

const BsipCallingPlanItem = (props) => {
  const {
    authorableContent: {
      planName,
      callInclusionsText,
      priceText,
      localCallsText,
      nationalCallsText,
      mobileCallsText,
      gstText,
    },
    id,
    planSelected,
    callingPlanCheckBoxChanged,
  } = props;

  return (
    <div className="row bsip-calling-plan-item">
      <div className="col-12">
        <strong>{planName}</strong>
      </div>
      <div className="col-12 custom-padding-16">
        <RadioButton
          id={id}
          iconType="tick"
          checked={planSelected}
          callBackAction={callingPlanCheckBoxChanged}
        />
      </div>
      <div className="col-12">
        {priceText}
      </div>
      <div className="col-12">
        {gstText}
      </div>
      <div className="col-12 custom-padding-8">
        <strong>{callInclusionsText}</strong>
      </div>
      <div className="col-12">
        {localCallsText}
      </div>
      <div className="col-12">
        {nationalCallsText}
      </div>
      <div className="col-12">
        {mobileCallsText}
      </div>
    </div>
  );
};

export default BsipCallingPlanItem;
